export const SET_USER = 'setUser'
export const RESET_USER_STATE = 'resetUserState'

export const SET_WEBSITES = 'setWebSites'

export const SET_TLDS = 'setTLDS'

export const SET_CATEGORIES = 'setCategories'
export const SET_CATEGORY = 'setCategory'

export const SET_TAGS = 'setTags'
export const SET_FILTER = 'setFilter'

export const RESET_STATE = 'resetState'